module.exports = __webpack_public_path__ + "static/media/comment-alt-check.b76dd9f2.svg";